import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface ExperimentsState {
    deviceId?: string;
    ineligibilityReason: string | null;
    isEligibleForAssignment: boolean | null;
    userProperties: {
        accept?: string;
        acceptLanguage?: string;
        asn?: string;
        cfBotScore?: number;
        ipAddress?: string;
        ja4?: string;
        userAgent?: string;
    };
}

const initialState = {
    deviceId: undefined,
    ineligibilityReason: null,
    isEligibleForAssignment: null,
    userProperties: {},
} satisfies ExperimentsState as ExperimentsState;

const experimentsSlice = createSlice({
    initialState,
    name: 'experiments',
    reducers: {
        experimentEligibilityReceived(state, action: PayloadAction<ExperimentsState>) {
            const {
                deviceId,
                isEligibleForAssignment,
                ineligibilityReason,
                userProperties,
            } = action.payload;

            state.deviceId = deviceId;
            state.isEligibleForAssignment = isEligibleForAssignment;
            state.ineligibilityReason = ineligibilityReason;
            state.userProperties = userProperties;
        },
    },
    selectors: {
        selectExperimentEligibility: (({
            deviceId,
            ineligibilityReason,
            isEligibleForAssignment,
            userProperties,
        }: ExperimentsState) => ({
            deviceId,
            ineligibilityReason,
            isEligibleForAssignment,
            userProperties,
        })),
    },
});

export type ExperimentEligibility =
    ReturnType<typeof experimentsSlice.selectors.selectExperimentEligibility>;

export const { actions, selectors } = experimentsSlice;
export const { experimentEligibilityReceived } = actions;
export default experimentsSlice.reducer;
